import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'

import OfflineImage from '@assets/images/offline.svg'
import Loader from '@/modules/base/components/loader/loader'
import OMOLogo from '@assets/images/logo/svg/logo.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

const useStyles = makeStyles(theme => ({
  container: ({ isOffline, isLoggedOut }) => ({
    position: 'fixed',
    display: (isOffline && !isLoggedOut) ? 'flex' : 'none',
    left: '0',
    top: '0',
    right: '0',
    bottom: '0',
    background: '#fff',
    zIndex: theme.zIndexes.offlineScreen,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.textColor,
  }),
  customClass: {
    position: 'relative',
    height: 'fit-content',
    width: 'fit-content',
  },
  logo: {
    marginTop: 25,
    height: 'fit-content',
  },
  svg: {
    marginBottom: 35,
  },
  headline: {
    fontSize: 36,
    lineHeight: '56px',
    letterSpacing: '0.36px',
    margin: '0 0 30px 0',
    textAlign: 'center',
  },
  text: {
    fontSize: 24,
    lineHeight: '36px',
    letterSpacing: '0.24',
    margin: 0,
    textAlign: 'center',
  },
}))

const Offline = () => {
  const { isOffline, isLoggedOut } = useSelector(state => state.global)
  const classes = useStyles({ isOffline, isLoggedOut })

  if (isOffline) {
    return (
      <div className={classes.container}>
        <Loader isVisible={isOffline} className={classes.customClass} />
        <SVGIcon width="192px" svg={OMOLogo} className={classes.logo} />
      </div>
    )
  }
  return (
    <div className={classes.container}>
      <div className={classes.svg}><SVGIcon height="160px" width="160px" svg={OfflineImage} /></div>
      <p className={classes.headline} dangerouslySetInnerHTML={{ __html: lang.offline.headline }} />
      <p className={classes.text} dangerouslySetInnerHTML={{ __html: lang.offline.text }} />
    </div>
  )
}

export default Offline
